import { StyleRulesCallback, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles: StyleRulesCallback = theme => ({
  root: {
    fontWeight: theme.typography.fontWeightMedium
  }
});

export const StyledTypography = withStyles(styles)(Typography);
